module.exports = __webpack_public_path__ + "img/credit-two.ea1f4b04.svg";